import { AxiosResponse } from 'axios'
import { Discount } from '../../const/benefits'
import {AxiosBackend} from "../../service/HTTP/AxiosInstance";

export const getPromotionCode = (
  code: string
): Promise<AxiosResponse<string>> => AxiosBackend.get(`/discount/${code}`)
export const getDiscounts = (): Promise<AxiosResponse<Discount[]>> =>
    AxiosBackend.get('/discount')
